
 <template lang="">
    <div class="text-center page">
    <v-dialog
      v-model="dialog"
      width="1000"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          color="red lighten-2"
          dark
          v-bind="attrs"
          v-on="on"
        >
          Click Me
        </v-btn>
      </template>

      <v-card>
        
         <FrmNewEvent></FrmNewEvent>
      </v-card>
    </v-dialog>
  </div>
  <!-- <v-container  >
        <v-row no-gutters>
            <v-col 
                cols="12"
                xs="12"
                sm="6"
                offset-sm="3"> 
            <v-modal>
                </v-modal>

            </v-col>
        </v-row>
  </v-container>  -->
 </template>
 <script>
     
 import FrmNewEvent from '../components/FrmNewEvent/FrmNewEvent'
import SessionHelper from "../utils/SessionHelper";
export default {
  mounted(){
    
    SessionHelper.checkRedirects(this.$route.params.companyAlias);
  },
     components:{
         FrmNewEvent
     },
      data () {
      return {
        dialog: false,
      }
    },
 }
 </script>
 <style lang=""> 
 </style>